import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { WebComponentsLoaderService } from '@shared/webcomponents/webcomponents-loader/webcomponents-loader.service';

export interface LocationPickerResult {
  coordinates: {
    lat: number;
    lng: number;
  };
}
@Component({
  selector: 'app-cw-location',
  template: '<rc-cw-location [attr.config]="config | json" (location)="onLocation($event)"></rc-cw-location>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CWLocationComponent {
  @Input() config: { api: 'google'; apiKey: string };
  @Output() public location: EventEmitter<LocationPickerResult> = new EventEmitter();

  constructor(private webComponentLoader: WebComponentsLoaderService, private cdr: ChangeDetectorRef) {
    this.webComponentLoader.loadDefaultComponents();
  }

  public onLocation(event: any) {
    event.stopPropagation();
    this.location.emit(event.detail as LocationPickerResult);
  }
}
